import { render, staticRenderFns } from "./UploadedFileDetails.vue?vue&type=template&id=1655ba51&scoped=true"
import script from "./UploadedFileDetails.vue?vue&type=script&lang=js"
export * from "./UploadedFileDetails.vue?vue&type=script&lang=js"
import style0 from "./UploadedFileDetails.vue?vue&type=style&index=0&id=1655ba51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1655ba51",
  null
  
)

export default component.exports